import React from "react";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";
import styled from "styled-components";

import { shouldShowField } from "../loanDetailEditUtil";

const DEFAULT_WIDTH = 160;
const StyledSpanText = styled.span`font-family: Roboto;`;

const CashManagementGeneralRow = {
  reportingWaiver: {
    isVisible: data => shouldShowField(data, "reportingWaiver"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => <StyledSpanText>{defaultField(data, "reportingWaiver")}</StyledSpanText>,
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingWaiverStartDate: {
    isVisible: data => shouldShowField(data, "reportingWaiverStartDate"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => <StyledSpanText>{defaultField(data, "reportingWaiverStartDate")}</StyledSpanText>,
        Cell: tableSideColumnMapper
      }
    ]
  },
  reportingWaiverEndDate: {
    isVisible: data => shouldShowField(data, "reportingWaiverEndDate"),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting Waiver End Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => <StyledSpanText>{defaultField(data, "reportingWaiverEndDate")}</StyledSpanText>,
        Cell: tableSideColumnMapper
      }
    ]
  }
};

export default CashManagementGeneralRow;
